import React from 'react';
import PropTypes from 'prop-types';
import TopBar from '@ajat/design-system/TopBar';
import { ComponentPage, DemoCard, ViewportFrame } from '../shared';

export const meta = {
  component: TopBar,
  title: 'Top Bar',
  group: 'Navigation',
  importPath: '@ajat/design-system/TopBar',
  figmaNode: '3848:18424',
  description:
    'The dark strip above the header. A centred notice at every width; the right-hand links appear from 1024px up and are hidden on mobile. It is a separate component — Header does not render it unless you pass showTopBar.',
  props: [
    ['brand', "'CLS' | 'ABC' | 'Overall'", "'CLS'", 'Brand — selects the default notice and links (Overall has none yet → CLS)'],
    ['notice', 'string', "'MORE THAN 75,000 CUSTOMERS ANNUALLY'", 'Centred notice text'],
    ['links', 'array', 'FAQ + Customer Service', '[{ label, href }] — desktop only'],
    ['className', 'string', "''", 'Additional CSS class'],
  ],
  usage: [
    {
      title: 'Standalone',
      code: `import TopBar from '@ajat/design-system/TopBar';

<TopBar
  brand="CLS"
  notice="FREE DELIVERY TO YOUR SCHOOL"
  links={[
    { label: 'FAQ', href: '/clothing/cls-dk/faq' },
    { label: 'CUSTOMER SERVICE', href: '/clothing/cls-dk/contact' },
  ]}
/>`,
    },
    {
      title: 'Through Header',
      code: `// Header can render it for you
<Header brand="CLS" showTopBar topBarNotice="…" topBarLinks={links} />`,
    },
  ],
};

export default function TopBarPage({ brand = 'CLS' }) {
  return (
    <ComponentPage meta={meta}>
      <DemoCard title="Desktop" hint="≥ 1024px · links visible" flush>
        <ViewportFrame width={1440} height={48} label="TopBar at 1440px">
          <TopBar brand={brand} />
        </ViewportFrame>
      </DemoCard>

      <DemoCard title="Custom notice and links" flush>
        <ViewportFrame width={1440} height={48} label="TopBar with custom links at 1440px">
          <TopBar
            brand={brand}
            notice="FREE DELIVERY TO YOUR SCHOOL"
            links={[
              { label: 'FAQ', href: '#' },
              { label: 'CUSTOMER SERVICE', href: '#' },
              { label: 'SIZE GUIDE', href: '#' },
            ]}
          />
        </ViewportFrame>
      </DemoCard>

      <DemoCard title="Mobile" hint="< 1024px · only the notice survives" flush>
        <ViewportFrame width={393} height={48} label="TopBar at 393px">
          <TopBar brand={brand} />
        </ViewportFrame>
      </DemoCard>
    </ComponentPage>
  );
}

TopBarPage.propTypes = {
  brand: PropTypes.oneOf(['CLS', 'ABC', 'Overall']),
};
